/*
 * terrassen-planner.js — Planer-Ansicht fuer den Terrassenplatten-Konfigurator
 *
 * Der Kern (terrassen-konfigurator.js) liegt nur minifiziert vor. Diese Datei greift deshalb
 * nicht in ihn ein, sondern setzt sich daneben: Sie liest ab, was der Kern ohnehin in die
 * Seite schreibt (Plattenname, Preis, Flaeche, den gezeichneten Plan) und spiegelt es in die
 * Kopfzeile ueber dem Plan. Alles, was der Kern per ID sucht, bleibt dabei unter seinem
 * Wurzelelement #mhKonfRoot - er findet es also auch nach dem Umbau des Layouts.
 *
 * Ansichten (Umschalter in der Kopfzeile):
 *   platten  Platten allein - ganze und zugeschnittene, ohne Unterkonstruktion
 *   uk       Unterbau allein - Profile, Laengsverbinder und Stelzlager, ohne Platten
 *   3d       raeumliche Ansicht der ganzen Terrasse (Three.js, erst beim ersten Aufruf geladen)
 * Dazu "AR ansehen": dieselbe Szene als GLB (Android/Desktop) bzw. USDZ (iOS) in
 * Originalgroesse - komplett im Browser erzeugt, ohne Server.
 *
 * Erkannt werden die Teile an den Farben, mit denen der Kern sie zeichnet:
 *   Platte #CFC9BC · Zuschnitt url(#mhCutHatch) · Profil #EE7402 · Verbinder #CF6304 ·
 *   Stelzlager #3A3B34
 * Der Kern zeichnet jede Platte - auch eine angeschnittene - in voller Groesse und beschneidet
 * sie erst ueber einen clipPath auf die Terrassenform. Die 3D-Ansicht rechnet diesen Schnitt
 * deshalb selbst nach (Rechteck gegen Umriss), sonst ragten Randplatten ueber die Kante.
 */
(function () {
  'use strict';

  var PLATE_FILLS = { '#CFC9BC': 1, 'url(#mhCutHatch)': 1 };
  var THREE_VER = '0.147.0';
  var CDN = 'https://cdn.jsdelivr.net/npm/three@' + THREE_VER;

  function boot() {
    var root = document.getElementById('mhKonfRoot');
    if (!root || root.__mhtp) return;
    root.__mhtp = true;

    function $(sel) { return root.querySelector(sel); }
    function setText(el, v) { if (el && el.textContent !== v) el.textContent = v; }
    function toast(msg) {
      var t = document.getElementById('toast'); if (!t) return;
      t.innerHTML = msg; t.classList.add('show');
      clearTimeout(t._mhtp); t._mhtp = setTimeout(function () { t.classList.remove('show'); }, 4200);
    }

    var D = window.MH_DATA || {}, ST = D.settings || {};
    var plan = $('#plan');
    var state = { mode: 'platten' };
    /* Fuer spaetere Ausbaustufen (Live-Ansicht) von aussen erreichbar. */
    window.MH_TERR_PLANNER = state;

    /* ---------- Bedienelemente, die nur die Planer-Ansicht braucht ----------
       Werden hier eingesetzt statt im Liquid, damit alles zur 3D-/AR-Ansicht in dieser
       einen Datei steht. */
    var vs = $('#viewSeg');
    if (vs && !vs.querySelector('[data-view="3d"]')) {
      var b3 = document.createElement('button');
      b3.type = 'button'; b3.setAttribute('data-view', '3d'); b3.textContent = '3D';
      vs.appendChild(b3);
    }
    var price = root.querySelector('.canvas-top .ct-price');
    if (price && !$('#tpArBtn')) {
      var ar = document.createElement('button');
      ar.type = 'button'; ar.id = 'tpArBtn'; ar.className = 'ct-ar';
      ar.title = 'Terrasse in Originalgröße im Raum ansehen'; ar.textContent = 'AR ansehen';
      price.parentNode.insertBefore(ar, price);
      ar.addEventListener('click', launchAR);
    }
    var host3d = $('#plan3d');
    if (!host3d && plan) {
      host3d = document.createElement('div');
      host3d.id = 'plan3d'; host3d.className = 'plan3d'; host3d.style.display = 'none';
      host3d.innerHTML = '<div class="plan3d-hint">3D-Ansicht · Ziehen zum Drehen · Scrollen zum Zoomen</div>';
      plan.parentNode.insertBefore(host3d, plan.nextSibling);
    }

    function verlegeart() {
      var c = root.querySelector('#verlegeChoices .choice.on[data-art]');
      return c ? c.getAttribute('data-art') : 'uk';
    }
    function formTxt() {
      var b = root.querySelector('#shapeSeg button.on');
      return b ? b.textContent.trim() : 'Rechteck';
    }
    function currentPlate() {
      var t = (($('#pchipTitle') || {}).textContent || '').replace(/^Terrassenplatte\s*/, '').trim();
      var fb = root.querySelector('#formatSeg button.on');
      var fmt = fb ? fb.getAttribute('data-fmt') : null;
      var list = D.platten || [];
      return list.filter(function (p) { return p.title === t && (!fmt || p.fmt === fmt); })[0]
        || list.filter(function (p) { return p.title === t; })[0] || null;
    }
    function hoeheMm() { var v = parseFloat(($('#hoehe') || {}).value); return v > 0 ? v : 120; }

    /* ---------- Kopfzeile ---------- */
    function updateTop() {
      var tv = $('#totalVal');
      setText($('#ctTotal'), tv ? tv.textContent : '0 €');

      var pt = $('#pchipTitle');
      if (pt && pt.textContent) setText($('#ctTitle'), pt.textContent);

      var ps = $('#pchipSwatch'), cs = $('#ctSwatch');
      if (ps && cs) {
        if (cs.style.backgroundColor !== ps.style.backgroundColor) cs.style.backgroundColor = ps.style.backgroundColor;
        if (cs.style.backgroundImage !== ps.style.backgroundImage) cs.style.backgroundImage = ps.style.backgroundImage;
      }

      var av = $('#areaVal');
      setText($('#ctStats'), (av ? av.textContent : '—') + ' · ' + formTxt());

      /* Bei loser Verlegung im Splittbett gibt es keinen Unterbau - dann auch keinen
         Umschalter dafuer. */
      var ub = root.querySelector('#viewSeg [data-view="uk"]');
      if (ub) {
        var ohne = verlegeart() === 'lose';
        if (ub.hidden !== ohne) ub.hidden = ohne;
        if (ohne && state.mode === 'uk') setMode('platten');
      }
    }

    /* ---------- Ansicht filtern ---------- */
    function show(el, on) { var v = on ? '' : 'none'; if (el.style.display !== v) el.style.display = v; }
    function applyView() {
      if (!plan) return;
      var uk = state.mode === 'uk', pl = state.mode === 'platten';
      Array.prototype.forEach.call(plan.querySelectorAll('rect'), function (r) {
        var f = r.getAttribute('fill');
        if (PLATE_FILLS[f]) show(r, !uk);
        else if (f === '#CF6304' && r.getAttribute('stroke') === '#F4F1EA') show(r, !pl);
      });
      Array.prototype.forEach.call(plan.querySelectorAll('line'), function (l) {
        if (l.getAttribute('stroke') !== '#EE7402') return;
        show(l, !pl);
        /* In der Unterbau-Ansicht treten die Profile etwas kraeftiger hervor, weil keine
           Platte mehr daneben liegt, an der sich das Auge orientiert. */
        var w = uk ? '3.6' : '';
        if (l.style.strokeWidth !== w) l.style.strokeWidth = w;
      });
      Array.prototype.forEach.call(plan.querySelectorAll('circle'), function (c) {
        if (c.getAttribute('fill') === '#3A3B34') show(c, !pl);
      });
      syncLegend();
      ukLabels(uk);
    }
    /* 28.10.2026 (MHC): Profilaufteilung im Unterbau-Plan. Der Kern zeichnet jedes Profilstueck als eigene
       Linie (#EE7402) und jeden Stoss als Verbinder-Quadrat (#CF6304); seit der 60-cm-Regel ist kein Stueck
       kuerzer als 60 cm (kurzes Stueck am Strangbeginn, Stoesse im Lagerraster). Hier werden nur die Laengen abgelesen (Plattenmassstab)
       und an EINER Reihe je Aufteilung beschriftet ("Reihen 1, 3, 5 …" bzw. "gilt fuer n Reihen"); dazu eine Legendenzeile.
       Stoesse sind seit 28.10.2026 versetzt (jede zweite Reihe gespiegelt, siehe TKcut im Kern).
       Idempotent ueber einen Schluessel, damit der MutationObserver sich nicht selbst weckt. */
    var ukKey = '';
    function ukLabels(on) {
      var old = plan.querySelectorAll('[data-tkuk]'), lg = $('#legend'), oldLg = lg ? lg.querySelector('[data-tkuk]') : null;
      var p = currentPlate(), rects = Array.prototype.filter.call(plan.querySelectorAll('rect'), function (r) { return PLATE_FILLS[r.getAttribute('fill')]; });
      var lines = Array.prototype.filter.call(plan.querySelectorAll('line'), function (l) { return l.getAttribute('stroke') === '#EE7402' && +l.getAttribute('stroke-width') > 2; });
      if (!on || !p || !rects.length || !lines.length || verlegeart() !== 'uk') {
        if (old.length || oldLg) { ukKey = ''; Array.prototype.forEach.call(old, function (n) { n.remove(); }); if (oldLg) oldLg.remove(); }
        return;
      }
      var s = Math.max(+rects[0].getAttribute('width'), +rects[0].getAttribute('height')) / Math.max(p.w || .6, p.h || .6);
      if (!(s > 0)) return;
      /* Straenge: achsparallele Linien mit gleicher Achse, Stoesse = Verbinder-Quadrate auf der Achse */
      var st = {};
      lines.forEach(function (l) {
        var x1 = +l.getAttribute('x1'), y1 = +l.getAttribute('y1'), x2 = +l.getAttribute('x2'), y2 = +l.getAttribute('y2');
        var v = Math.abs(x1 - x2) < .5, h = Math.abs(y1 - y2) < .5; if (!v && !h) return;
        var k = (v ? 'v' : 'h') + Math.round(v ? x1 : y1);
        var o = st[k] || (st[k] = { v: v, ax: v ? x1 : y1, a: 1e9, b: -1e9, j: [] });
        o.a = Math.min(o.a, v ? Math.min(y1, y2) : Math.min(x1, x2)); o.b = Math.max(o.b, v ? Math.max(y1, y2) : Math.max(x1, x2));
      });
      Array.prototype.forEach.call(plan.querySelectorAll('rect'), function (r) {
        if (r.getAttribute('fill') !== '#CF6304' || r.getAttribute('stroke') !== '#F4F1EA') return;
        var cx = +r.getAttribute('x') + +r.getAttribute('width') / 2, cy = +r.getAttribute('y') + +r.getAttribute('height') / 2;
        Object.keys(st).forEach(function (k) { var o = st[k]; if (Math.abs((o.v ? cx : cy) - o.ax) < 1.5) o.j.push(o.v ? cy : cx); });
      });
      var fmt = function (m) { return (Math.round(m * 10) / 10).toFixed(1).replace('.', ',') + ' m'; };
      var groups = {}, order = [], allK = Object.keys(st).sort(function (a, b) { return st[a].ax - st[b].ax; });
      var rows = function (ns) { /* "1, 3, 5 … 15" */
        if (ns.length <= 4) return ns.join(', ');
        var d = ns[1] - ns[0], ar = ns.every(function (x, i) { return !i || x - ns[i - 1] === d; });
        return ar ? ns[0] + ', ' + ns[1] + ', ' + ns[2] + ' … ' + ns[ns.length - 1] : ns.slice(0, 3).join(', ') + ' …';
      };
      allK.forEach(function (k, ix) {
        var o = st[k]; o.no = ix + 1; if (o.j.length < 1) return;
        var cuts = [o.a].concat(o.j.sort(function (a, b) { return a - b; })).concat([o.b]);
        o.pcs = []; for (var i = 1; i < cuts.length; i++) o.pcs.push({ a: cuts[i - 1], b: cuts[i], m: (cuts[i] - cuts[i - 1]) / s });
        var sig = (o.v ? 'v:' : 'h:') + o.pcs.map(function (q) { return fmt(q.m); }).join(' + ');
        if (!groups[sig]) { groups[sig] = []; order.push(sig); }
        groups[sig].push(o);
      });
      var key = order.map(function (g) { return g + '|' + groups[g].length + '|' + groups[g][0].ax.toFixed(1); }).join(';') + '|' + s.toFixed(3);
      if (key === ukKey && old.length) return;
      ukKey = key;
      Array.prototype.forEach.call(old, function (n) { n.remove(); }); if (oldLg) oldLg.remove();
      var NS = 'http://www.w3.org/2000/svg';
      order.forEach(function (sig) {
        var g = groups[sig], o = g[Math.floor((g.length - 1) / 2)], iL = 0;
        o.pcs.forEach(function (q, i) { if (q.m > o.pcs[iL].m) iL = i; });
        o.pcs.forEach(function (q, i) {
          var mid = (q.a + q.b) / 2, lab = fmt(q.m) + (g.length > 1 && i === iL ? (g.length === allK.length ? ' · gilt für ' + g.length + ' Reihen' : ' · Reihen ' + rows(g.map(function (x) { return x.no; }))) : '');
          var x = o.v ? o.ax + 10 : mid, y = o.v ? mid : o.ax - 8;
          var t = document.createElementNS(NS, 'text');
          var at = { x: x.toFixed(1), y: y.toFixed(1), 'text-anchor': 'middle', 'dominant-baseline': 'central', 'font-family': 'Inter,Arial,sans-serif', 'font-size': 9.5, 'font-weight': 700, fill: '#1B1B19', stroke: '#FFFFFF', 'stroke-width': 3.2, 'paint-order': 'stroke', 'data-tkuk': '1' };
          if (o.v) at.transform = 'rotate(-90 ' + x.toFixed(1) + ' ' + y.toFixed(1) + ')';
          Object.keys(at).forEach(function (a) { t.setAttribute(a, at[a]); });
          t.textContent = lab; plan.appendChild(t);
        });
      });
      if (lg && order.length) {
        var sp = document.createElement('span'); sp.setAttribute('data-tkuk', '1');
        sp.textContent = 'Profil-Aufteilung (Stöße versetzt): ' + order.map(function (sig) { var g = groups[sig]; return (g.length > 1 ? 'Reihen ' : 'Reihe ') + rows(g.map(function (x) { return x.no; })) + ': ' + sig.slice(2); }).join(' · ') + ' · Mindeststück 60 cm, kürzere Reste = Abfall · Quadrat = Längsverbinder am Profilstoß';
        lg.appendChild(sp);
      }
    }
    /* Die Legende zeigt nur, was in der aktuellen Ansicht auch zu sehen ist. */
    function syncLegend() {
      var lg = $('#legend'); if (!lg) return;
      Array.prototype.forEach.call(lg.children, function (sp) {
        var tx = sp.textContent || '';
        var isUk = /profil|verbinder|stelzlager/i.test(tx);
        var isPlatte = /^Platte/.test(tx);
        var on = state.mode === 'uk' ? !isPlatte : (state.mode === 'platten' ? !isUk : true);
        show(sp, on);
      });
    }

    function setMode(m) {
      state.mode = m;
      Array.prototype.forEach.call(root.querySelectorAll('#viewSeg button'), function (b) {
        b.classList.toggle('on', b.getAttribute('data-view') === m);
      });
      applyView();
      var is3d = m === '3d';
      if (plan) plan.style.display = is3d ? 'none' : '';
      if (host3d) host3d.style.display = is3d ? 'block' : 'none';
      if (is3d) ensureThree(function () { init3D(); rebuild3D(); });
      root.dispatchEvent(new CustomEvent('mhtp:view', { detail: { mode: m } }));
    }
    state.setMode = setMode;

    if (vs) vs.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button[data-view]');
      if (!b || b.hidden) return;
      setMode(b.getAttribute('data-view'));
    });

    /* =====================================================================
       3D-Ansicht
       Three.js r147 (UMD von jsdelivr), erst beim ersten Umschalten geladen. Die Szene
       entsteht 1:1 aus dem gezeichneten Plan: Platten-Rechtecke, Profil-Linien und
       Stelzlager-Punkte werden ueber den Plattenmassstab in Meter zurueckgerechnet.
       ===================================================================== */
    var three = null;
    function ensureThree(cb) {
      if (window.THREE && window.THREE.OrbitControls) { cb(); return; }
      if (ensureThree._q) { ensureThree._q.push(cb); return; }
      ensureThree._q = [cb];
      loadScript(CDN + '/build/three.min.js', function () {
        loadScript(CDN + '/examples/js/controls/OrbitControls.js', function () {
          var q = ensureThree._q || []; ensureThree._q = null;
          q.forEach(function (f) { f(); });
        });
      }, function () { ensureThree._q = null; toast('3D-Ansicht konnte nicht geladen werden — bitte Seite neu laden.'); });
    }
    function loadScript(src, ok, fail) {
      var sc = document.createElement('script');
      sc.src = src; sc.onload = ok; sc.onerror = fail || function () {};
      document.head.appendChild(sc);
    }
    function init3D() {
      if (three || !window.THREE || !host3d) return;
      var T = window.THREE;
      var W = host3d.clientWidth || 700, H = Math.max(300, Math.min(560, Math.round(W * .62)));
      var renderer = new T.WebGLRenderer({ antialias: true });
      renderer.setPixelRatio(Math.min(2, window.devicePixelRatio || 1));
      renderer.setSize(W, H);
      if (T.sRGBEncoding !== undefined) renderer.outputEncoding = T.sRGBEncoding;
      host3d.appendChild(renderer.domElement);
      var scene = new T.Scene();
      scene.background = new T.Color(0xf3f1ec).convertSRGBToLinear();
      var camera = new T.PerspectiveCamera(45, W / H, .05, 200);
      var controls = new T.OrbitControls(camera, renderer.domElement);
      controls.enableDamping = true;
      controls.maxPolarAngle = Math.PI / 2 - .04;
      controls.minDistance = 1.2; controls.maxDistance = 60;
      /* Lichtsumme wie beim WPC-Konfigurator auf ~1.0 austariert, sonst wirkt der
         Plattenton ausgewaschen. */
      scene.add(new T.AmbientLight(0xffffff, .5));
      var sun = new T.DirectionalLight(0xffffff, .62);
      sun.position.set(6, 10, 4); scene.add(sun);
      var ground = new T.Mesh(new T.PlaneGeometry(120, 120), new T.MeshLambertMaterial({ color: new T.Color(0xdcd6c8).convertSRGBToLinear() }));
      ground.rotation.x = -Math.PI / 2; ground.position.y = -.002; scene.add(ground);
      three = { renderer: renderer, scene: scene, camera: camera, controls: controls, group: null, fitted: false, lastSpan: 0 };
      (function loop() { three.raf = requestAnimationFrame(loop); controls.update(); renderer.render(scene, camera); })();
      window.addEventListener('resize', function () {
        if (!three || !host3d.clientWidth) return;
        var w = host3d.clientWidth, h = Math.max(300, Math.min(560, Math.round(w * .62)));
        three.renderer.setSize(w, h); three.camera.aspect = w / h; three.camera.updateProjectionMatrix();
      });
    }

    /* ---------- Plattenoberflaeche ----------
       Die Produktfotos sind Stimmungsbilder: schraeg aufgenommen, mit Fugen und Blaettern.
       Als Textur taugen sie nicht. Gemessen wird deshalb nur der echte Plattenton (mittleres
       Helligkeitsband der Bildmitte; Blattgruen, Glanzlichter und Fugen fallen heraus), und
       daraus entsteht eine massstabsgetreue Feinsteinzeug-Oberflaeche: ruhige, grossflaechige
       Wolken wie bei Beton- und Steinoptik, darauf feines Korn. Vier Varianten, damit
       benachbarte Platten nicht identisch aussehen. */
    var texCache = {}, colCache = {};
    function measureColor(img) {
      try {
        var S = 96, cv = document.createElement('canvas'); cv.width = S; cv.height = S;
        var cx = cv.getContext('2d', { willReadFrequently: true });
        cx.drawImage(img, 0, 0, S, S);
        var o = Math.round(S * .12), n = Math.round(S * .76);
        var d = cx.getImageData(o, o, n, n).data, px = [];
        for (var i = 0; i < d.length; i += 4) {
          var r = d[i], g = d[i + 1], b = d[i + 2];
          if (d[i + 3] < 200) continue;
          var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
          if (mx > 0 && (mx - mn) / mx > .28) continue;     /* Blaetter, Farbstiche */
          if (mx > 248) continue;                            /* Glanzlicht */
          if (mx < 24) continue;                             /* Fuge, harter Schatten */
          px.push([r, g, b, r * .299 + g * .587 + b * .114]);
        }
        if (px.length < 80) return null;
        px.sort(function (a, b2) { return a[3] - b2[3]; });
        var lo = Math.floor(px.length * .35), hi = Math.max(lo + 1, Math.ceil(px.length * .8));
        var R = 0, G = 0, B = 0;
        for (var k = lo; k < hi; k++) { R += px[k][0]; G += px[k][1]; B += px[k][2]; }
        var m = hi - lo;
        return { r: Math.round(R / m), g: Math.round(G / m), b: Math.round(B / m) };
      } catch (e) { return null; }
    }
    function buildTexture(T, col, seed) {
      var N = 512, cv = document.createElement('canvas'); cv.width = N; cv.height = N;
      var g = cv.getContext('2d');
      var rnd = (function (s) { return function () { s = (s * 9301 + 49297) % 233280; return s / 233280; }; })(seed * 7919 + 13);
      function CH(k, a) {
        var c = function (v) { return Math.max(0, Math.min(255, Math.round(v * k))); };
        return 'rgba(' + c(col.r) + ',' + c(col.g) + ',' + c(col.b) + ',' + (a === undefined ? 1 : a) + ')';
      }
      g.fillStyle = CH(1); g.fillRect(0, 0, N, N);
      /* 1) grosse, weiche Wolken */
      for (var i = 0; i < 26; i++) {
        var x = rnd() * N, y = rnd() * N, r = N * (.12 + rnd() * .3);
        var gr = g.createRadialGradient(x, y, 0, x, y, r);
        var k = rnd() < .5 ? .9 + rnd() * .06 : 1.04 + rnd() * .06;
        gr.addColorStop(0, CH(k, .22)); gr.addColorStop(1, CH(k, 0));
        g.fillStyle = gr; g.fillRect(0, 0, N, N);
      }
      /* 2) feines Korn */
      var id = g.getImageData(0, 0, N, N), dd = id.data;
      for (var p = 0; p < dd.length; p += 4) {
        var n = (rnd() - .5) * 14;
        dd[p] = Math.max(0, Math.min(255, dd[p] + n));
        dd[p + 1] = Math.max(0, Math.min(255, dd[p + 1] + n));
        dd[p + 2] = Math.max(0, Math.min(255, dd[p + 2] + n));
      }
      g.putImageData(id, 0, 0);
      /* 3) vereinzelte dunkle Einschluesse, wie bei Steinoptik */
      for (var j = 0; j < 140; j++) {
        g.fillStyle = CH(.72 + rnd() * .12, .35 + rnd() * .3);
        g.beginPath(); g.arc(rnd() * N, rnd() * N, .6 + rnd() * 1.6, 0, Math.PI * 2); g.fill();
      }
      var tex = new T.CanvasTexture(cv);
      tex.wrapS = tex.wrapT = T.RepeatWrapping;
      if (T.sRGBEncoding !== undefined) tex.encoding = T.sRGBEncoding;
      tex.anisotropy = 8;
      return tex;
    }
    /* Splitt: dunkler als jede Platte, damit sich die Flaeche klar abhebt. Eine Kachel = 0,5 m. */
    var gravelTex = null;
    function gravelTexture(T) {
      if (gravelTex) return gravelTex;
      var N = 256, cv = document.createElement('canvas'); cv.width = N; cv.height = N;
      var g = cv.getContext('2d');
      var rnd = (function (s) { return function () { s = (s * 9301 + 49297) % 233280; return s / 233280; }; })(777);
      g.fillStyle = '#7d776d'; g.fillRect(0, 0, N, N);
      for (var i = 0; i < 2600; i++) {
        var v = 90 + Math.round(rnd() * 90), w = Math.round(rnd() * 10) - 5;
        g.fillStyle = 'rgb(' + (v + w) + ',' + (v + w - 4) + ',' + (v - 10) + ')';
        g.beginPath(); g.ellipse(rnd() * N, rnd() * N, 1 + rnd() * 2.2, .8 + rnd() * 1.6, rnd() * Math.PI, 0, Math.PI * 2); g.fill();
      }
      gravelTex = new T.CanvasTexture(cv);
      gravelTex.wrapS = gravelTex.wrapT = T.RepeatWrapping;
      gravelTex.repeat.set(2, 2);
      if (T.sRGBEncoding !== undefined) gravelTex.encoding = T.sRGBEncoding;
      return gravelTex;
    }
    function plateMaterials(T, p) {
      var url = p && p.img;
      if (url && colCache[url] === undefined) {
        colCache[url] = null;
        var im = new Image(); im.crossOrigin = 'anonymous';
        im.onload = function () { var c = measureColor(im); if (c) { colCache[url] = c; rebuild3D(); } };
        im.src = url;
      }
      var col = (url && colCache[url]) || { r: 205, g: 200, b: 190 };
      var key = (url || 'x') + '|' + col.r + ',' + col.g + ',' + col.b;
      if (!texCache[key]) {
        texCache[key] = [0, 1, 2, 3].map(function (s) { return buildTexture(T, col, s + 1); });
      }
      return texCache[key].map(function (tx) {
        /* Eine Textur deckt 1,2 m - so haben 60er- und 120er-Platten dieselbe Koernung. */
        return new T.MeshLambertMaterial({ map: tx, color: new T.Color(1, 1, 1) });
      });
    }

    /* ---------- Geometrie aus dem Plan ---------- */
    function clipPoly() {
      var cp = plan && plan.querySelector('clipPath path'); if (!cp) return null;
      var nums = (cp.getAttribute('d') || '').match(/-?\d+(?:\.\d+)?/g); if (!nums) return null;
      var pts = [];
      for (var i = 0; i + 1 < nums.length; i += 2) pts.push([+nums[i], +nums[i + 1]]);
      return pts.length >= 3 ? pts : null;
    }
    /* Sutherland-Hodgman: Umriss der Terrasse gegen das (konvexe) Plattenrechteck. So
       rum gerechnet stimmt es auch fuer L-Formen, deren Umriss nicht konvex ist. */
    function clipToRect(poly, x0, y0, x1, y1) {
      var edges = [
        [function (p) { return p[0] >= x0; }, function (a, b) { var t = (x0 - a[0]) / (b[0] - a[0]); return [x0, a[1] + t * (b[1] - a[1])]; }],
        [function (p) { return p[0] <= x1; }, function (a, b) { var t = (x1 - a[0]) / (b[0] - a[0]); return [x1, a[1] + t * (b[1] - a[1])]; }],
        [function (p) { return p[1] >= y0; }, function (a, b) { var t = (y0 - a[1]) / (b[1] - a[1]); return [a[0] + t * (b[0] - a[0]), y0]; }],
        [function (p) { return p[1] <= y1; }, function (a, b) { var t = (y1 - a[1]) / (b[1] - a[1]); return [a[0] + t * (b[0] - a[0]), y1]; }]
      ];
      var out = poly;
      edges.forEach(function (e) {
        var inp = out; out = [];
        for (var i = 0; i < inp.length; i++) {
          var cur = inp[i], prev = inp[(i + inp.length - 1) % inp.length];
          var ci = e[0](cur), pi = e[0](prev);
          if (ci) { if (!pi) out.push(e[1](prev, cur)); out.push(cur); }
          else if (pi) out.push(e[1](prev, cur));
        }
      });
      return out;
    }
    function polyArea(pts) {
      var a = 0;
      for (var i = 0, j = pts.length - 1; i < pts.length; j = i++) a += pts[j][0] * pts[i][1] - pts[i][0] * pts[j][1];
      return Math.abs(a / 2);
    }

    var rb3dT = null;
    function rebuildSoon() { clearTimeout(rb3dT); rb3dT = setTimeout(rebuild3D, 120); }
    function rebuild3D() {
      if (!three || !window.THREE || !plan) return;
      var T = window.THREE;
      if (three.group) {
        three.scene.remove(three.group);
        three.group.traverse(function (o) { if (o.geometry) o.geometry.dispose(); });
        three.group = null;
      }
      var p = currentPlate();
      var rects = Array.prototype.filter.call(plan.querySelectorAll('rect'), function (r) { return PLATE_FILLS[r.getAttribute('fill')]; });
      if (!p || !rects.length) return;
      /* Massstab: der Kern zeichnet jede Platte in voller Groesse (auch angeschnittene),
         also ist die laengere Rechteckseite genau die laengere Plattenkante. */
      var rw = +rects[0].getAttribute('width'), rh = +rects[0].getAttribute('height');
      var s = Math.max(rw, rh) / Math.max(p.w || .6, p.h || .6);
      if (!(s > 0)) return;
      var poly = clipPoly();
      var art = verlegeart();
      var plateT = (ST.plateMm || 20) / 1000, ukH = (ST.ukMm || 31) / 1000;
      var top = art === 'lose' ? plateT + .05 : Math.max(plateT + .012, hoeheMm() / 1000);
      var pedH = art === 'uk' ? Math.max(.008, top - plateT - ukH) : Math.max(.008, top - plateT);
      var C = function (h) { return new T.Color(h).convertSRGBToLinear(); };
      var mats = plateMaterials(T, p);
      var matUK = new T.MeshLambertMaterial({ color: C(0x9ea3a8) });
      var matPed = new T.MeshLambertMaterial({ color: C(0x3a3b34) });
      var matBed = new T.MeshLambertMaterial({ map: gravelTexture(T), color: new T.Color(1, 1, 1) });
      var g = new T.Group();
      var minX = 1e9, maxX = -1e9, minZ = 1e9, maxZ = -1e9, k = 0;
      var rnd = (function (s0) { return function () { s0 = (s0 * 9301 + 49297) % 233280; return s0 / 233280; }; })(42);

      /* 13.10.2026: Sicherheits-Review (S5) – Obergrenze fuer Einzel-Meshes. Bei sehr vielen Platten
         (ueber MAX_3D) gibt es statt je Platte ein Mesh nur eine durchgehende Flaeche im Umriss
         (oder im Rechteck aller Platten) - die Seite bleibt bedienbar, Unterbau und Lager entfallen. */
      var MAX_3D = 6000, simple = rects.length > MAX_3D;
      if (simple) {
        var bx0 = 1e9, by0 = 1e9, bx1 = -1e9, by1 = -1e9;
        rects.forEach(function (r) {
          var x0 = +r.getAttribute('x'), y0 = +r.getAttribute('y'), w = +r.getAttribute('width'), h = +r.getAttribute('height');
          if (x0 < bx0) bx0 = x0; if (y0 < by0) by0 = y0; if (x0 + w > bx1) bx1 = x0 + w; if (y0 + h > by1) by1 = y0 + h;
        });
        var sp = poly || [[bx0, by0], [bx1, by0], [bx1, by1], [bx0, by1]];
        var ss = new T.Shape();
        sp.forEach(function (q, i) { var lx = q[0] / s, ly = -q[1] / s; if (i) ss.lineTo(lx, ly); else ss.moveTo(lx, ly); });
        var sm = new T.Mesh(new T.ExtrudeGeometry(ss, { depth: plateT, bevelEnabled: false }), mats[0]);
        sm.rotation.x = -Math.PI / 2;
        sm.position.set(0, top - plateT, 0);
        g.add(sm);
        sp.forEach(function (q) {
          var X = q[0] / s, Z = q[1] / s;
          if (X < minX) minX = X; if (X > maxX) maxX = X; if (Z < minZ) minZ = Z; if (Z > maxZ) maxZ = Z;
        });
        if (!three.simpleHint) { three.simpleHint = true; toast('Sehr große Fläche — die 3D-Ansicht zeigt eine vereinfachte Darstellung.'); }
      }

      if (!simple) rects.forEach(function (r) {
        var x0 = +r.getAttribute('x'), y0 = +r.getAttribute('y');
        var w = +r.getAttribute('width'), h = +r.getAttribute('height');
        var pts = [[x0, y0], [x0 + w, y0], [x0 + w, y0 + h], [x0, y0 + h]];
        if (r.getAttribute('fill') !== '#CFC9BC' && poly) pts = clipToRect(poly, x0, y0, x0 + w, y0 + h);
        if (pts.length < 3 || polyArea(pts) < 1e-3 * s * s) return;
        var shape = new T.Shape();
        pts.forEach(function (q, i) {
          var lx = (q[0] - x0) / s, ly = -(q[1] - y0) / s;
          if (i) shape.lineTo(lx, ly); else shape.moveTo(lx, ly);
        });
        var geo = new T.ExtrudeGeometry(shape, { depth: plateT, bevelEnabled: false });
        /* UV: 1 Einheit = 1 m, eine Textur = 1,2 m; dazu ein zufaelliger Versatz je Platte */
        var uv = geo.attributes.uv, ou = rnd(), ov = rnd();
        for (var i = 0; i < uv.count; i++) uv.setXY(i, uv.getX(i) / 1.2 + ou, uv.getY(i) / 1.2 + ov);
        uv.needsUpdate = true;
        var m = new T.Mesh(geo, mats[(k++) % mats.length]);
        m.rotation.x = -Math.PI / 2;
        m.position.set(x0 / s, top - plateT, y0 / s);
        g.add(m);
        pts.forEach(function (q) {
          var X = q[0] / s, Z = q[1] / s;
          if (X < minX) minX = X; if (X > maxX) maxX = X; if (Z < minZ) minZ = Z; if (Z > maxZ) maxZ = Z;
        });
      });

      if (art === 'uk' && !simple) {
        Array.prototype.forEach.call(plan.querySelectorAll('line'), function (l) {
          if (l.getAttribute('stroke') !== '#EE7402') return;
          var x1 = +l.getAttribute('x1') / s, z1 = +l.getAttribute('y1') / s;
          var x2 = +l.getAttribute('x2') / s, z2 = +l.getAttribute('y2') / s;
          var len = Math.hypot(x2 - x1, z2 - z1); if (len < .05) return;
          var m = new T.Mesh(new T.BoxGeometry(.04, ukH, len), matUK);
          m.position.set((x1 + x2) / 2, pedH + ukH / 2, (z1 + z2) / 2);
          m.rotation.y = Math.atan2(x2 - x1, z2 - z1);
          g.add(m);
        });
      }
      if (art === 'lose') {
        /* Splittbett folgt dem Umriss - bei L- und Freiform also keine Kiesflaeche in der
           Aussparung. */
        var bp = poly || (minX < maxX ? [[minX * s, minZ * s], [maxX * s, minZ * s], [maxX * s, maxZ * s], [minX * s, maxZ * s]] : null);
        if (bp) {
          var bs = new T.Shape();
          bp.forEach(function (q, i) { var lx = q[0] / s, ly = -q[1] / s; if (i) bs.lineTo(lx, ly); else bs.moveTo(lx, ly); });
          var bed = new T.Mesh(new T.ExtrudeGeometry(bs, { depth: top - plateT, bevelEnabled: false }), matBed);
          bed.rotation.x = -Math.PI / 2;
          g.add(bed);
        }
      } else if (!simple) {
        Array.prototype.forEach.call(plan.querySelectorAll('circle'), function (c) {
          if (c.getAttribute('fill') !== '#3A3B34') return;
          var x = +c.getAttribute('cx') / s, z = +c.getAttribute('cy') / s;
          var m = new T.Mesh(new T.CylinderGeometry(.05, .085, pedH, 16), matPed);
          m.position.set(x, pedH / 2, z);
          g.add(m);
        });
      }

      if (minX > maxX) { minX = 0; maxX = 5; minZ = 0; maxZ = 4; }
      var cx = (minX + maxX) / 2, cz = (minZ + maxZ) / 2, span = Math.max(maxX - minX, maxZ - minZ, 2);
      g.position.set(-cx, 0, -cz);
      three.scene.add(g); three.group = g;
      if (!three.fitted || Math.abs(three.lastSpan - span) > .5) {
        three.camera.position.set(span * .85, span * .7, span * 1.05);
        three.controls.target.set(0, top, 0);
        three.fitted = true; three.lastSpan = span;
      }
    }

    /* =====================================================================
       AR - wie beim WPC-Konfigurator: iOS bekommt eine USDZ fuer AR Quick Look, alle
       anderen eine GLB, die Googles model-viewer in WebXR/Scene Viewer oeffnet.
       ===================================================================== */
    var AR = { busy: false };
    /* 13.10.2026: Sicherheits-Review (S10) – Blob-URLs nach Gebrauch wieder freigeben (Quick Look bzw.
       model-viewer brauchen die Adresse nur kurz nach dem Oeffnen). */
    function arRevoke(url, ms) { if (!url) return; setTimeout(function () { try { URL.revokeObjectURL(url); } catch (e) {} }, ms || 60000); }
    function isIOS() { return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); }
    function ensureExporters(cb) {
      ensureThree(function () {
        if (THREE.GLTFExporter && THREE.USDZExporter) { cb(); return; }
        var fail = function () { AR.busy = false; toast('AR-Export konnte nicht geladen werden — bitte Seite neu laden.'); };
        loadScript(CDN + '/examples/js/libs/fflate.min.js', function () {
          loadScript(CDN + '/examples/js/exporters/GLTFExporter.js', function () {
            loadScript(CDN + '/examples/js/exporters/USDZExporter.js', cb, fail);
          }, fail);
        }, fail);
      });
    }
    function buildARScene() {
      /* Exporter verstehen nur MeshStandardMaterial - Farbe und Textur werden umkopiert.
         Masse bleiben in Metern, AR zeigt die Terrasse also in Originalgroesse. */
      if (!three || !three.group) return null;
      var T = window.THREE, out = new T.Group(), ios = isIOS(), matC = {}, texC = {};
      /* 02.10.2026: AR auf dem iPhone oeffnete nicht - der Export brauchte ueber 4 s, weil jede
         Plattentextur als verlustfreies PNG kodiert wurde (rund 1 s je Textur). Safari oeffnet
         AR Quick Look aber nur kurz nach dem Antippen. Jetzt: Texturen als JPEG, ein Material
         je Ausgangsmaterial statt je Teil (167 -> 7). */
      function arTex(m) {
        if (!m) return null;
        if (!texC[m.id]) {
          var t = m.clone(); t.needsUpdate = true;
          t.userData = Object.assign({}, m.userData, { mimeType: 'image/jpeg' });   /* GLB (Android) */
          if (ios) t.format = 1022;   /* nicht RGBA -> der USDZ-Export schreibt JPEG statt PNG */
          texC[m.id] = t;
        }
        return texC[m.id];
      }
      three.group.traverse(function (o) {
        if (!o.isMesh) return;
        var src = o.material || {};
        var mat = matC[src.uuid] || (matC[src.uuid] = new T.MeshStandardMaterial({ color: src.color ? src.color.clone() : new T.Color(.6, .6, .6), map: arTex(src.map), roughness: .85, metalness: 0 }));
        var mesh = new T.Mesh(o.geometry, mat);
        o.updateWorldMatrix(true, false);
        mesh.applyMatrix4(o.matrixWorld);
        out.add(mesh);
      });
      /* Welt-Matrizen der losgeloesten Gruppe berechnen - der USDZ-Export liest matrixWorld,
         sonst landen alle Teile uebereinander im Ursprung. */
      out.updateMatrixWorld(true);
      return out.children.length ? out : null;
    }
    function openArOverlay(url) {
      var ov = document.getElementById('tpArOverlay');
      if (!ov) {
        ov = document.createElement('div'); ov.id = 'tpArOverlay'; ov.className = 'mh-ar-overlay';
        var cl = document.createElement('button');
        cl.type = 'button'; cl.className = 'mh-ar-close'; cl.textContent = '✕ Schließen';
        cl.onclick = function () { ov.style.display = 'none'; var mv0 = ov.querySelector('model-viewer'); if (mv0) mv0.remove(); arRevoke(ov._mhUrl, 0); ov._mhUrl = null; };
        ov.appendChild(cl);
        document.body.appendChild(ov);
      }
      ov.style.display = 'block';
      if (ov._mhUrl && ov._mhUrl !== url) arRevoke(ov._mhUrl, 0);
      ov._mhUrl = url;
      var old = ov.querySelector('model-viewer'); if (old) old.remove();
      var make = function () {
        var mv = document.createElement('model-viewer');
        mv.setAttribute('src', url);
        mv.setAttribute('ar', ''); mv.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
        mv.setAttribute('camera-controls', ''); mv.setAttribute('shadow-intensity', '1');
        mv.setAttribute('ar-scale', 'fixed');
        mv.setAttribute('alt', '3D-Modell deiner Terrassenplanung');
        mv.style.cssText = 'width:100%;height:100%;background:#f3f1ec';
        ov.appendChild(mv);
        try { mv.dismissPoster(); } catch (e) {}
        mv.addEventListener('load', function () { arRevoke(url); try { if (mv.canActivateAR) mv.activateAR(); } catch (e) {} });
        mv.addEventListener('error', function () { arRevoke(url, 1000); });
      };
      if (window.customElements && customElements.get('model-viewer')) make();
      else {
        var sc = document.createElement('script'); sc.type = 'module';
        sc.src = 'https://cdn.jsdelivr.net/npm/@google/model-viewer@3.5.0/dist/model-viewer.min.js';
        sc.onload = make;
        sc.onerror = function () { AR.busy = false; toast('AR-Viewer konnte nicht geladen werden — bitte Seite neu laden.'); };
        document.head.appendChild(sc);
      }
    }
    function startAR() {
      var scene = buildARScene();
      if (!scene) { AR.busy = false; toast('Bitte zuerst eine Fläche planen.'); return; }
      var T = window.THREE;
      try {
        if (isIOS()) {
          new T.USDZExporter().parse(scene).then(function (data) {
            var url = URL.createObjectURL(new Blob([data], { type: 'model/vnd.usdz+zip' }));
            /* Nur kurz nach dem Antippen darf die Seite AR Quick Look selbst oeffnen. Dauerte es
               laenger (z. B. beim ersten Laden der 3D-Bibliothek), erscheint ein Knopf, den der
               Kunde direkt antippt - das oeffnet Quick Look immer. */
            if (Date.now() - AR.t0 < 900) {
              var a = document.getElementById('tpArAnchor');
              if (!a) {
                a = document.createElement('a'); a.id = 'tpArAnchor'; a.rel = 'ar';
                a.style.cssText = 'position:absolute;left:-9999px;top:0';
                a.appendChild(document.createElement('img')); /* Pflicht, sonst navigiert Safari statt Quick Look */
                document.body.appendChild(a);
              }
              a.href = url; a.click();
              arRevoke(url);
            } else arTapSheet(url);
            AR.busy = false;
          }, function () { AR.busy = false; toast('AR konnte nicht gestartet werden.'); });
        } else {
          new T.GLTFExporter().parse(scene, function (ab) {
            openArOverlay(URL.createObjectURL(new Blob([ab], { type: 'model/gltf-binary' })));
            AR.busy = false;
          }, function () { AR.busy = false; toast('AR konnte nicht gestartet werden.'); }, { binary: true });
        }
      } catch (e) { AR.busy = false; toast('AR konnte nicht gestartet werden.'); }
    }
    /* Hinweisfenster mit echtem AR-Link (rel="ar" mit Bild als einzigem Inhalt - so verlangt es
       Safari). Das Bild ist der Knopf selbst, auf ein Canvas gezeichnet. */
    function arBtnImg() {
      var k = 2, w = 240, h = 52, c = document.createElement('canvas'); c.width = w * k; c.height = h * k;
      var g = c.getContext('2d'); g.scale(k, k);
      g.fillStyle = '#D27437'; g.beginPath();
      if (g.roundRect) g.roundRect(0, 0, w, h, h / 2); else g.rect(0, 0, w, h);
      g.fill();
      g.fillStyle = '#fff'; g.font = '700 17px Inter, -apple-system, Helvetica, Arial, sans-serif';
      g.textAlign = 'center'; g.textBaseline = 'middle'; g.fillText('In AR öffnen', w / 2, h / 2 + 1);
      return c.toDataURL('image/png');
    }
    function arTapSheet(url) {
      var sh = document.getElementById('tpArSheet');
      if (!sh) {
        sh = document.createElement('div'); sh.id = 'tpArSheet';
        sh.style.cssText = 'position:fixed;inset:0;z-index:2147483640;background:rgba(27,27,25,.55);display:flex;align-items:flex-end;justify-content:center;padding:16px;font-family:inherit';
        sh.innerHTML = '<div style="width:100%;max-width:420px;background:#fff;border-radius:18px;padding:20px 18px 16px;text-align:center;box-shadow:0 12px 40px rgba(0,0,0,.25)">'
          + '<div style="font-size:17px;font-weight:700;color:#1B1B19;margin-bottom:6px">Deine Terrasse ist bereit</div>'
          + '<div style="font-size:13.5px;line-height:1.45;color:#5b5a55;margin-bottom:14px">Tippe auf den Knopf – die Terrasse erscheint in Originalgröße vor dir.</div>'
          + '<a rel="ar" id="tpArLink" style="display:inline-block;line-height:0"><img alt="In AR öffnen" width="240" height="52" style="display:block;width:240px;height:52px"></a>'
          + '<button type="button" data-x style="display:block;margin:12px auto 0;background:none;border:0;color:#5b5a55;font-size:14px;font-weight:600;text-decoration:underline;cursor:pointer;font-family:inherit">Schließen</button></div>';
        sh.querySelector('img').src = arBtnImg();
        sh.addEventListener('click', function (e) { if (e.target === sh || e.target.closest('[data-x]')) sh.style.display = 'none'; });
        sh.querySelector('#tpArLink').addEventListener('click', function () { setTimeout(function () { sh.style.display = 'none'; }, 600); arRevoke(sh._mhUrl); });
        document.body.appendChild(sh);
      }
      if (sh._mhUrl && sh._mhUrl !== url) arRevoke(sh._mhUrl, 0);
      sh._mhUrl = url;
      sh.querySelector('#tpArLink').href = url;
      sh.style.display = 'flex';
    }
    function launchAR() {
      if (AR.busy) return;
      AR.busy = true; AR.t0 = Date.now();
      toast('AR wird vorbereitet …');
      ensureThree(function () { init3D(); rebuild3D(); ensureExporters(startAR); });
    }
    state.launchAR = launchAR;

    /* ---------- Beobachten ----------
       Der Kern zeichnet den Plan bei jeder Aenderung komplett neu und setzt Preise und
       Texte direkt ins DOM. Ein einziger Beobachter am Wurzelelement merkt das; gearbeitet
       wird hoechstens einmal je Durchlauf. Eigene Schreibzugriffe aendern nur Werte, die
       sich wirklich unterscheiden - sonst wuerde sich der Beobachter selbst endlos wecken. */
    var queued = false;
    function refresh() {
      queued = false;
      try { updateTop(); applyView(); } catch (e) { /* Kopfzeile darf den Kern nie stoeren */ }
    }
    function queue() {
      if (queued) return;
      queued = true;
      /* Als Microtask: laeuft direkt nachdem der Kern fertig gezeichnet hat, noch vor dem
         naechsten Bildaufbau - der Plan blitzt also nie ungefiltert auf. Anders als
         requestAnimationFrame laeuft das auch in einem nicht sichtbaren Tab. */
      Promise.resolve().then(refresh);
    }
    if (window.MutationObserver) {
      new MutationObserver(queue).observe(root, {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['class']
      });
      /* Nur ein neu gezeichneter Plan baut die 3D-Szene neu - nicht jede andere Aenderung. */
      if (plan) new MutationObserver(function () { if (three && state.mode === '3d') rebuildSoon(); else if (three) three.stale = true; })
        .observe(plan, { childList: true });
    }
    root.addEventListener('mhtp:view', function (e) {
      if (e.detail && e.detail.mode === '3d' && three && three.stale) { three.stale = false; rebuildSoon(); }
    });
    queue();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();